import React, { useState } from 'react'
import styled from 'styled-components'
import { useDispatch } from 'react-redux'
import { Text } from '../Text'
import { EmailTextBox } from '../TextBox/EmailTextBox'
import { PasswordTextBox } from '../TextBox/PasswordTextBox'
import { Button, ButtonThemeType } from '../Button'
import { showModal } from '../../states/modals/actions'
import { ModalType } from '../../states/modals/ModalType.constants'
import { Link } from '../Link'
import { Form } from './Form'
import { ButtonType } from '../Button/ButtonType.constants'
import {
  forgotPassword,
  forgotPasswordSubmit,
} from '../../states/currentUser/actions'
import { VerificationCodeTextBox } from '../TextBox/VerificationCodeTextBox'
import { STYLES } from '../../static/style'

type ForgotFormProps = {
  showBackToLogin?: boolean
}

const LoginLink = styled(Link)`
  display: block;
  width: 100%;
  margin-top: 1rem;
`

const SendCodeButton = styled(Button).attrs({
  theme: ButtonThemeType.PRIMARY,
  type: ButtonType.SUBMIT,
})`
  border-radius: 0 ${STYLES.BORDER_RADIUS} ${STYLES.BORDER_RADIUS} 0;
  font-size: ${STYLES.FONT_SIZE_XS};
  width: auto;
`

const CountDownText = styled(Text)`
  font-size: ${STYLES.FONT_SIZE_XS};
  color: ${STYLES.COLOR_PALE_SKY_GRAY};
`

const StyledButton = styled(Button)`
  margin-top: 1rem;
`

const COUNTDOWN_SECOND = 60

const ForgotForm = ({ showBackToLogin }: ForgotFormProps) => {
  const dispatch = useDispatch()
  const [formFields, setFormFields] = useState({})
  const [isDisableSendCodeButton, setIsDisableSendCodeButton] = useState(false)
  const [enableCountDown, setEnableCountDown] = useState<number>(null)

  const runCountDown = (nextCount: number) => {
    setTimeout(() => {
      setEnableCountDown(nextCount)
      if (nextCount > 0) {
        runCountDown(nextCount - 1)
      } else {
        setIsDisableSendCodeButton(false)
      }
    }, 1000)
  }
  const startCountDown = () => {
    setEnableCountDown(COUNTDOWN_SECOND)
    runCountDown(COUNTDOWN_SECOND - 1)
  }

  return (
    <>
      <Form
        formFields={formFields}
        onChange={(ff) => setFormFields(ff)}
        onSubmit={() => {
          if (!isDisableSendCodeButton) {
            dispatch(forgotPassword(formFields.email))
            setIsDisableSendCodeButton(true)
            startCountDown()
          }
        }}
      >
        <EmailTextBox
          labelText="Email"
          name="email"
          validation="email"
          required
          rightChildren={
            <SendCodeButton disabled={isDisableSendCodeButton}>
              Send code
              {isDisableSendCodeButton && (
                <CountDownText>&nbsp;{enableCountDown}s</CountDownText>
              )}
            </SendCodeButton>
          }
        />
      </Form>
      <Form
        formFields={formFields}
        onChange={(ff) => setFormFields(ff)}
        onSubmit={() => {
          const { email, newPassword, verificationCode } = formFields
          dispatch(forgotPasswordSubmit(email, newPassword, verificationCode))
        }}
      >
        <PasswordTextBox
          labelText="New password"
          name="newPassword"
          validation="password"
          required
        />
        <VerificationCodeTextBox
          labelText="Verification Code"
          name="verificationCode"
          validation="verificationCode"
          required
        />
        <StyledButton
          label="Submit"
          theme={ButtonThemeType.PRIMARY}
          type={ButtonType.SUBMIT}
        >
          Submit
        </StyledButton>
        {showBackToLogin && (
          <LoginLink
            onClick={() => {
              dispatch(showModal(ModalType.LOGIN))
            }}
          >
            &lt; Back to Login
          </LoginLink>
        )}
      </Form>
    </>
  )
}

export { ForgotForm }
